module.exports = __webpack_public_path__ + "img/ditbenik1.bf00c8ec.jpg";